import styled from 'react-emotion';

export const AulaEditorWrapper = styled('div')`
  ${({ readOnly }) => (readOnly ? 'opacity: 0.5;' : '')}
`;

export default {};
